import API from "../AxiosClient";
import ErrorHelper from "../../helpers/ErrorHelper";
import TokenDAO from "../../DAO/TokenDAO";

export default class AutenticacaoService {

	static async login(data) {
		try {
			const loginResponse = await API.post("/auth/login/", data);
			return loginResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async logout() {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/auth/logout/`, {}, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async usuarioAutenticado(token) {
		try {
			token = `Token ${token}`;

			const usuarioResponse = await API.get(`/auth/profile/`, {
				headers: {
					Authorization: token
				}
			});

			return usuarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async recuperarSenha(data) {
		try {
			const recuperarResponse = await API.post("/auth/password/reset/", data);
			return recuperarResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async verificarPkParaRedefinicaoDeSenha(pk) {
		try {
			const verificacaoResponse = await API.get(`/auth/password/reset/${pk}/`);
			return verificacaoResponse.data;
		} catch (error) {

			if (error && error.response && error.response.status == 404) {
				throw error;
			}

			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async redefinirSenha(pk, data) {
		try {
			const redefinicaoResponse = await API.post(`/auth/password/reset/${pk}/`, data);
			return redefinicaoResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}
}
